export default "__VITE_ASSET__D$P2xwLg__"